import React, { Children } from 'react';
import { motion } from 'framer-motion';
const bullets = ['Congress success depends on converting awareness into booth visits — but most HCPs never make it past the aisle.', 'We need qualified engagement at the booth, but HCPs must feel comfortable crossing that "imaginary border" from passive browsing to active conversation.', 'The funnel leaks at every stage: Pre-Congress awareness → Vicinity nudging → Venue arrival → Aisle browsing → Booth commitment.', 'Our solution: Address each conversion point with bite-sized Snaks™ that meet HCPs where they are — lowering barriers at every stage of the funnel.'];
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.4
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    x: -20
  },
  show: {
    opacity: 1,
    x: 0
  }
};
function CongressZonesDiagram() {
  return <svg viewBox="0 0 320 320" className="w-full h-full" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-285">
      {/* Pre-Congress — outermost */}
      <rect x="8" y="8" width="304" height="304" rx="32" ry="32" stroke="#E60012" strokeWidth="2" strokeDasharray="4 4" fill="none" opacity="0.6" data-id="element-286" />
      <text x="160" y="30" textAnchor="middle" fill="#E60012" fontSize="13" fontWeight="600" opacity="0.9" data-id="element-287">
        Pre-Congress
      </text>

      {/* Vicinity */}
      <rect x="36" y="44" width="248" height="248" rx="20" ry="20" stroke="#E60012" strokeWidth="2.5" strokeDasharray="10 6" fill="none" opacity="0.7" data-id="element-288" />
      <text x="160" y="64" textAnchor="middle" fill="#E60012" fontSize="13" fontWeight="600" data-id="element-289">
        Vicinity
      </text>

      {/* Venue */}
      <rect x="68" y="80" width="184" height="196" rx="8" ry="8" fill="#CC0010" fillOpacity="0.25" stroke="#CC0010" strokeWidth="1.5" data-id="element-290" />
      <text x="160" y="100" textAnchor="middle" fill="white" fontSize="13" fontWeight="600" opacity="0.9" data-id="element-291">
        Venue
      </text>

      {/* Aisle */}
      <rect x="100" y="112" width="120" height="100" rx="4" ry="4" fill="#E60012" fillOpacity="0.3" stroke="#E60012" strokeWidth="1.5" data-id="element-292" />
      <text x="160" y="132" textAnchor="middle" fill="white" fontSize="12" fontWeight="600" opacity="0.9" data-id="element-293">
        Aisle
      </text>

      {/* Booth — innermost */}
      <rect x="120" y="144" width="80" height="40" rx="4" ry="4" fill="#E60012" fillOpacity="0.5" stroke="#E60012" strokeWidth="1.5" data-id="element-294" />
      <text x="160" y="169" textAnchor="middle" fill="white" fontSize="12" fontWeight="700" data-id="element-295">
        Booth
      </text>

      {/* Arrows pointing inward */}
      <defs data-id="element-296">
        <marker id="arrowhead" markerWidth="8" markerHeight="6" refX="7" refY="3" orient="auto" data-id="element-297">
          <polygon points="0 0, 8 3, 0 6" fill="white" fillOpacity="0.7" data-id="element-298" />
        </marker>
      </defs>
      <line x1="80" y1="92" x2="118" y2="140" stroke="white" strokeWidth="1.2" opacity="0.5" markerEnd="url(#arrowhead)" data-id="element-299" />
      <line x1="240" y1="92" x2="202" y2="140" stroke="white" strokeWidth="1.2" opacity="0.5" markerEnd="url(#arrowhead)" data-id="element-300" />
      <line x1="80" y1="264" x2="118" y2="196" stroke="white" strokeWidth="1.2" opacity="0.5" markerEnd="url(#arrowhead)" data-id="element-301" />
      <line x1="240" y1="264" x2="202" y2="196" stroke="white" strokeWidth="1.2" opacity="0.5" markerEnd="url(#arrowhead)" data-id="element-302" />
      <line x1="80" y1="162" x2="118" y2="162" stroke="white" strokeWidth="1.2" opacity="0.5" markerEnd="url(#arrowhead)" data-id="element-303" />
      <line x1="240" y1="162" x2="202" y2="162" stroke="white" strokeWidth="1.2" opacity="0.5" markerEnd="url(#arrowhead)" data-id="element-304" />
    </svg>;
}
export function SlideChallenges() {
  return <div className="h-full w-full relative overflow-hidden" data-id="element-305">
      <div className="absolute inset-0 bg-[#1A1A2E]" data-id="element-306" />

      <div className="absolute top-0 right-0 w-[55%] h-full pointer-events-none" style={{
      background: 'linear-gradient(135deg, transparent 0%, rgba(230,0,18,0.1) 50%, rgba(197,0,15,0.15) 100%)',
      clipPath: 'polygon(20% 0%, 100% 0%, 100% 100%, 0% 100%, 30% 50%)'
    }} data-id="element-307" />

      <div className="relative z-10 h-full w-full p-10 md:p-14 flex" data-id="element-308">
        <div className="flex flex-col flex-1 max-w-[50%]" data-id="element-309">
          <motion.div className="flex items-center gap-3 mb-8" initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-310">
            <div className="w-8 h-[2px] bg-[#E60012]" data-id="element-311" />
            <span className="text-white/70 text-sm font-medium tracking-wide" data-id="element-312">
              Snakker™ for Congress
            </span>
          </motion.div>

          <motion.h2 className="text-4xl md:text-5xl font-bold text-white mb-8 max-w-lg" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.15
        }} data-id="element-313">
            The Conversion Challenge
          </motion.h2>

          <motion.ul className="space-y-5 max-w-lg flex-1" variants={container} initial="hidden" animate="show" data-id="element-314">
            {bullets.map((text, i) => <motion.li key={i} variants={item} className="flex items-start gap-4" data-id="element-315">
                <div className="w-2 h-2 rounded-full bg-[#E60012] mt-2.5 shrink-0" data-id="element-316" />
                <p className="text-white/85 text-base leading-relaxed" data-id="element-317">
                  {text}
                </p>
              </motion.li>)}
          </motion.ul>
        </div>

        <motion.div className="flex flex-col items-center justify-center w-[440px] shrink-0" initial={{
        opacity: 0,
        scale: 0.85
      }} animate={{
        opacity: 0.9,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} data-id="element-318">
          <CongressZonesDiagram data-id="element-319" />
          <motion.p className="text-[11px] text-[#E60012]/70 text-center mt-3 italic" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 1.2
        }} data-id="element-320">
            The congress conversion zones — each layer is a barrier to cross
          </motion.p>
        </motion.div>
      </div>
    </div>;
}